module.exports = __webpack_public_path__ + "static/media/TransactionFeature3.3dffa3fe.avif";